import { GitBranchPlus } from "lucide-react";
import { Button } from "../../../../../../shared/components/button/Button";
import { forwardRef } from "react";

const ObjectivesTrackerCreateTriggerButton = forwardRef((props, ref) => {
  return (
    <Button
      {...props}
      aria-haspopup="true"
      size="icon"
      variant="ghost"
      ref={ref}
    >
      <GitBranchPlus className="h-4 w-4" />
      <span className="sr-only">Toggle menu</span>
    </Button>
  );
});

export default ObjectivesTrackerCreateTriggerButton;
